export default "__VITE_ASSET__DLFFcRly__"